module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/1tiWo8Alr7uxAN6jqtyAxA-3363ce2c12ab233d268807fb9d133f26.jpg";